<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'App'
}
</script>

<style>
body{
  margin: 0;
}
#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif;
   */
  font-family: "DM Sans", Gilroy, -apple-system, "Sofia Pro", "Microsoft YaHei", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue